(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserActivationController', UserActivationController);

    UserActivationController.$inject = ['UserActivation', 'UserActivationSearch'];

    function UserActivationController(UserActivation, UserActivationSearch) {

        var vm = this;

        vm.userActivations = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            UserActivation.query(function(result) {
                vm.userActivations = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            UserActivationSearch.query({query: vm.searchQuery}, function(result) {
                vm.userActivations = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
